export default __webpack_public_path__ + "static/media/visanew.f226f5dc.png";